export var PaymentType;
(function (PaymentType) {
    PaymentType["SUBSCRIPTION"] = "subscription";
    PaymentType["RENT"] = "rent";
    PaymentType["PURCHASE"] = "sale";
    PaymentType["MEMBER_ONLY"] = "memberOnly";
    PaymentType["PLAN"] = "plan";
})(PaymentType || (PaymentType = {}));
//# sourceMappingURL=payment-type.js.map